import { TFunction } from "i18next";

const tableHeaders = (t: TFunction) => [
  {
    label: t("paymentConfigurations.fiscalName"),
    align: "left" as const
  },
  {
    label: t("paymentConfigurations.fiscalId")
  },
  {
    label: t("paymentConfigurations.status")
  }
];

export { tableHeaders };
